(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[36],{

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_TICKET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_TICKET_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORT_TAXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOURISTIC_TAXES; });
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
var PRICE_TICKET_REQUEST_ABORT = 'PRICE_TICKET_REQUEST_ABORT';
var PORT_TAXES = 'PORT_TAXES';
var TOURISTIC_TAXES = 'TOURISTIC_TAXES';

/***/ }),

/***/ "15pl":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "1aYn":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    isArrayLike = __webpack_require__("9y2L"),
    keys = __webpack_require__("BlJA");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "6Wi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PushAppBanner_PushAppBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// CONCATENATED MODULE: ./src/utils/platforms/platforms.utils.js


var isIOS = function isIOS() {
  if (!navigator) {
    return false;
  }

  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod', 'MacIntel'].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes('Mac') && 'ontouchend' in document;
};
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/widgets/push-app-banner/PushAppBanner.jsx





var __jsx = react_default.a.createElement;










var PushAppBanner_PushAppBanner = function PushAppBanner(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      onClickStoreBtn = _ref.onClickStoreBtn,
      _ref$qrImgUrl = _ref.qrImgUrl,
      qrImgUrl = _ref$qrImgUrl === void 0 ? '/img/app-qr-code-black.png' : _ref$qrImgUrl;
  var isFeatureFlipped = Object(useFeatureFlip["a" /* useFeatureFlip */])('appBanner.enabled');

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  var narrowImageUrl = Object(i18n["h" /* t */])('appBanner.narrowImageUrl') && Object(i18n["h" /* t */])('appBanner.narrowImageUrl') !== 'appBanner.narrowImageUrl' ? Object(i18n["h" /* t */])('appBanner.narrowImageUrl') : '/img/bg-pushappbanner-narrow.jpg';
  var largeImageUrl = Object(i18n["h" /* t */])('appBanner.largeImageUrl') && Object(i18n["h" /* t */])('appBanner.largeImageUrl') !== 'appBanner.largeImageUrl' ? Object(i18n["h" /* t */])('appBanner.largeImageUrl') : '/img/bg-pushappbanner-large.jpg'; // Use large image for medium breakpoint and above (md: in Tailwind)

  var backgroundImageUrl = isBrowserGreaterThan.S ? largeImageUrl : narrowImageUrl;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  if (!isFeatureFlipped) {
    return null;
  }

  var loc = locale.toLowerCase();
  var btns = [{
    img: "https://apple-resources.s3.amazonaws.com/media-badges/download-on-the-app-store/black/".concat(loc, ".svg"),
    className: 'h-48',
    label: Object(i18n["h" /* t */])('appBanner.cta'),
    onClick: function onClick() {
      return onClickStoreBtn === null || onClickStoreBtn === void 0 ? void 0 : onClickStoreBtn('apple_store');
    },
    url: Object(i18n["h" /* t */])('appBanner.appleStoreLink')
  }, {
    img: "https://play.google.com/intl/".concat(loc.replace('-', '_'), "/badges/static/images/badges/").concat(loc.slice(0, 2), "_badge_web_generic.png"),
    className: 'h-[62px] -mt-[7px]',
    label: Object(i18n["h" /* t */])('appBanner.cta'),
    onClick: function onClick() {
      return onClickStoreBtn === null || onClickStoreBtn === void 0 ? void 0 : onClickStoreBtn('google_play');
    },
    url: Object(i18n["h" /* t */])('appBanner.googleStoreLink')
  }];
  var isIOSPlatform = isIOS();
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('h-[345px] max-w-[345px]', 'md:h-[326px] md:max-w-site-medium', 'relative isolate w-full overflow-hidden rounded-12 bg-lightGrey bg-cover bg-center bg-no-repeat px-20 py-30 md:px-70 md:py-60', className),
    style: {
      backgroundImage: "url(\"".concat(backgroundImageUrl, "\")")
    },
    "data-testid": "push-app-banner"
  }, __jsx("div", {
    className: "relative isolate z-1 flex h-full flex-col text-14 text-white md:block md:max-w-3/5"
  }, __jsx("h2", {
    className: "mb-10 font-brand text-24 font-normal md:text-44"
  }, Object(i18n["h" /* t */])('appBanner.title')), __jsx("p", {
    className: "mb-5"
  }, Object(i18n["h" /* t */])('appBanner.description')), __jsx("ul", {
    className: "mb-5 px-5"
  }, Object(i18n["e" /* getListValue */])('appBanner.texts').map(function (txt) {
    return __jsx("li", {
      className: "list-disc",
      key: txt
    }, txt);
  })), __jsx("div", {
    className: "mt-20 hidden gap-20 md:flex"
  }, btns.map(function (btn) {
    return __jsx(DynamicLink["a" /* default */], {
      isExternalLink: true,
      key: btn.url,
      onClick: btn.onClick,
      url: btn.url
    }, __jsx("img", {
      alt: btn.label,
      className: btn.className,
      src: btn.img,
      onError: function onError(_ref2) {
        var currentTarget = _ref2.currentTarget;
        currentTarget.onerror = null; // prevents looping

        currentTarget.src = 'https://apple-resources.s3.amazonaws.com/media-badges/download-on-the-app-store/black/en-us.svg';
      }
    }));
  })), __jsx(Button["a" /* Button */], {
    className: "mx-40 mt-auto md:hidden",
    colorBg: colors["a" /* COLORS */].WHITE,
    color: colors["a" /* COLORS */].BLACK,
    onClick: onClick,
    url: isIOSPlatform ? Object(i18n["h" /* t */])('appBanner.appleStoreLink') : Object(i18n["h" /* t */])('appBanner.googleStoreLink')
  }, Object(i18n["h" /* t */])('appBanner.cta'))), __jsx("div", {
    className: "absolute end-0 top-0 mx-15 mt-[165px] flex h-[296px] w-[148px] flex-col items-center justify-center bg-[url('/img/iphone-placeholder.png')] bg-no-repeat text-white md:mx-70 md:mt-15"
  }, __jsx("img", {
    alt: "",
    className: "hidden w-[115px] md:block",
    src: qrImgUrl
  }), __jsx("p", {
    className: "mt-10 hidden text-14 md:block"
  }, Object(i18n["h" /* t */])('appBanner.scanCodeLabel'))));
};

/***/ }),

/***/ "E8Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFromUppercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capitalizeWordFirstCaracter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__);







function capitalize(string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

var capitalizeFromUppercase = function capitalizeFromUppercase(str) {
  return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(str.toLowerCase());
};
var capitalizeWordFirstCaracter = function capitalizeWordFirstCaracter(str) {
  return str === null || str === void 0 ? void 0 : str.toLowerCase().split(' ').map(function (w) {
    return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(w);
  }).join(' ');
};


/***/ }),

/***/ "JRz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useUpliftConfirmation; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Ub5k");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hi3+");
/* harmony import */ var _script__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("MZRd");
/* harmony import */ var _UpliftForm_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("NYMU");












var useUpliftConfirmation = function useUpliftConfirmation(_ref) {
  var booking = _ref.booking,
      currency = _ref.currency,
      paymentStatus = _ref.paymentStatus,
      _ref$shouldConfirm = _ref.shouldConfirm,
      shouldConfirm = _ref$shouldConfirm === void 0 ? true : _ref$shouldConfirm;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_5__[/* useAppContext */ "c"])(),
      locale = _useAppContext.locale,
      country = _useAppContext.country;

  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_7__["useRouter"])();
  var query = router.query;
  var upliftCode = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get("psp.uplift.".concat(country, ".code"));
  var order = Object(_UpliftForm_utils__WEBPACK_IMPORTED_MODULE_11__[/* buildOrder */ "a"])(booking);
  var configuration = {
    apiKey: _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('psp.uplift.apiKey'),
    locale: locale,
    currency: currency,
    checkout: true,
    channel: 'desktop',
    container: '#uplift-container'
  };

  var confirmationCallback = function confirmationCallback() {
    var isErrored = paymentStatus === _utils_payment_constants__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_STATUS_FAILURE */ "m"] || paymentStatus === _utils_payment_constants__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_STATUS_REFUSED_PSP */ "r"];
    Object(_UpliftForm_utils__WEBPACK_IMPORTED_MODULE_11__[/* trackUplift */ "b"])({
      orderId: booking.bookingId,
      isErrored: isErrored,
      errorMsg: isErrored ? paymentStatus : ''
    });
    var newUri = new urijs__WEBPACK_IMPORTED_MODULE_8___default.a(router.asPath).removeQuery(['bnpl']);
    router.replace(newUri.toString());
  };

  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    if (shouldConfirm && query.bnpl) {
      upliftCode && Object(_script__WEBPACK_IMPORTED_MODULE_10__[/* loadUplift */ "a"])(upliftCode);

      window.upReady = function () {
        window.Uplift.Payments.init(configuration);
        window.Uplift.Payments.load(order);
        confirmationCallback();
      };
    }
  }, [query.bnpl, shouldConfirm]);
};

/***/ }),

/***/ "JYr1":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dSaG");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(state) {
  return (state === null || state === void 0 ? void 0 : state.tripInformation) || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref2) {
  var adults = _ref2.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var kids = _ref4.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var mainContact = _ref5.mainContact;
  return mainContact;
});


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js
var variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var variant = _ref.variant;
    return {
      thRoot: "".concat(variant ? variants[variant].root : '', " bg-saffron border-saffron text-black relative isolate bg-saffron border-saffron size-50 text-black border-1 flex-none inline-flex items-center justify-center leading-0 overflow-hidden"),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-[1em] text-center ".concat(variant ? variants[variant].item : '')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx


var __jsx = react_default.a.createElement;




var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["alt", "className", "iconName", "iconSize", "label", "theme", "variant"]);

  if (!iconName && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), !!iconName && __jsx("span", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("span", {
    className: thLabel
  }, label));
};

/***/ }),

/***/ "VqLN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var isInteger = __webpack_require__("JYr1");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* unused harmony export ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__MORE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* unused harmony export ID_MODAL_HEADER__BE__CXO_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* unused harmony export ID_MODAL_HEADER__BE__CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__EASY_ARRIVAL_INFO; });
/* unused harmony export ID_MODAL_HEADER__BE__HOUSEHOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE_REFRESH_PROPOSAL; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE = 'TransportsFiltersMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
var ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
var ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';

/***/ }),

/***/ "iNQX":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__FwMss","list":"Breadcrumb_list__2T7rX"};

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return synchronizeChildcareQPWithKidsQP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFacetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateActiveFacetsQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasDepartureCityAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterFacetsToHide; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInactiveFacetValues; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VqLN");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zygG");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("sW3P");
































var _facetsQueryParamMapp;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_CRITERIA_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_CITY_FACET_ID */ "r"]);
}

function getInactiveFacetValues(facets, activeFacets, facetId) {
  var _matchingFacet$list$m, _matchingFacet$list, _activeFacets$facetId;

  var _facets$filter = facets.filter(function (_ref) {
    var id = _ref.id;
    return id === facetId;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_facets$filter, 1),
      matchingFacet = _facets$filter2[0];

  var matchingFacetValues = (_matchingFacet$list$m = matchingFacet === null || matchingFacet === void 0 ? void 0 : (_matchingFacet$list = matchingFacet.list) === null || _matchingFacet$list === void 0 ? void 0 : _matchingFacet$list.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })) !== null && _matchingFacet$list$m !== void 0 ? _matchingFacet$list$m : [];
  var matchingActiveFacetValues = Object.keys((_activeFacets$facetId = activeFacets[facetId]) !== null && _activeFacets$facetId !== void 0 ? _activeFacets$facetId : {});
  return matchingFacetValues.filter(function (option) {
    return !matchingActiveFacetValues.includes(option);
  });
}

function filterFacetsToHide(facets, facetsToHide) {
  var facetIdsWithOptionsToHide = Object.keys(facetsToHide !== null && facetsToHide !== void 0 ? facetsToHide : {});
  return facets.map(function (facet) {
    if (facetIdsWithOptionsToHide.includes(facet.id)) {
      return _objectSpread(_objectSpread({}, facet), {}, {
        list: facet.list.filter(function (_ref3) {
          var value = _ref3.value;
          return !facetsToHide[facet.id].includes(value);
        })
      });
    }

    return facet;
  });
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facet, 'selected');
  });
  return selectedCity ? lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_31___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(timestampDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_31___default()(), 'day') : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_31___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"]) {
    return lodash_times__WEBPACK_IMPORTED_MODULE_30___default()(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_31___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function convertQueryParamToKids(value) {
  if (!value) {
    return [];
  }

  return value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
}

function convertKidsToChildcareQueryParam(_ref4) {
  var departureDate = _ref4.departureDate,
      kids = _ref4.kids;

  if (!departureDate) {
    return [];
  }

  return kids.reduce(function (acc, _ref5) {
    var birthdate = _ref5.birthdate;
    return birthdate ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(acc), [moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate).diff(moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate), 'months')]) : acc;
  }, []).map(function (diffInMonths) {
    if (diffInMonths >= 4 && diffInMonths < 24) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_0_TO_2 */ "i"];
    }

    if (diffInMonths >= 24 && diffInMonths < 48) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_2_TO_3 */ "k"];
    }

    if (diffInMonths >= 48 && diffInMonths < 132) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_4_TO_10 */ "l"];
    }

    if (diffInMonths >= 132 && diffInMonths < 216) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_11_TO_17 */ "j"];
    }

    return '';
  }).filter(Boolean);
}

function unserializeKidsFromQueryParam(value, isSeller) {
  var maxKidsNumber = isSeller ? _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX_SELLER */ "H"] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"];

  if (!value) {
    return [];
  }

  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > maxKidsNumber) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) {
    return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]));
  }

  var kids = convertQueryParamToKids(value);
  return kids.length > maxKidsNumber ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref6, index) {
    var birthdate = _ref6.birthdate,
        childcareIncluded = _ref6.childcareIncluded;

    if (!birthdate || !kidsValidationState || (kidsValidationState === null || kidsValidationState === void 0 ? void 0 : kidsValidationState.length) > 0 && kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"]);
    return childcareIncluded ? "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });
    return childcareIncluded ? "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]);
};
var synchronizeChildcareQPWithKidsQP = function synchronizeChildcareQPWithKidsQP(_ref7) {
  var childcareFacetQueryParam = _ref7.childcareFacetQueryParam,
      departureDate = _ref7.departureDate,
      departureDateQueryParam = _ref7.departureDateQueryParam,
      kids = _ref7.kids,
      _ref7$kidsQueryParam = _ref7.kidsQueryParam,
      kidsQueryParam = _ref7$kidsQueryParam === void 0 ? '' : _ref7$kidsQueryParam;
  var previousDepartureDate = formatDepartureDateForStore(departureDateQueryParam, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]);
  var previousKids = convertQueryParamToKids(kidsQueryParam);
  var previousChildcareIncluded = previousKids.some(function (kid) {
    return kid.childcareIncluded;
  });
  var childcareIncluded = kids.some(function (kid) {
    return kid.childcareIncluded;
  });

  if (!childcareIncluded && !previousChildcareIncluded) {
    // childcareIncluded checkbox unchecked and unchanged => no override
    return undefined;
  }

  var childcareRemoved = previousChildcareIncluded && !childcareIncluded;
  var kidsRemoved = previousKids.length > 0 && kids.length === 0;

  if (childcareRemoved || kidsRemoved) {
    // childcareIncluded checkbox unchecked or kids removed from FilterWho => reset childcare filter
    return '';
  } // childcareIncluded checkbox checked => override childcare filter with matching kids age range and existing childcare options


  var childcareFilterOptionsFromPreviousKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: previousDepartureDate,
    kids: previousKids
  })));

  var childcareFilterOptionsFromKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: departureDate,
    kids: kids
  })));

  var childcareFilterOptionsToRemove = childcareFilterOptionsFromPreviousKids.filter(function (option) {
    return !childcareFilterOptionsFromKids.includes(option);
  });
  var chilcareFilterOptions = childcareFacetQueryParam.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(childcareFilterOptionsFromKids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(chilcareFilterOptions.filter(function (option) {
    return !childcareFilterOptionsToRemove.includes(option);
  }))))).filter(Boolean).join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref8) {
  var birthdate = _ref8.birthdate,
      departureDate = _ref8.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_31___default()().add(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "s"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var customFacetsQueryParamMapping = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_34__[/* FLIGHT_DURATION_FACET_ID */ "C"], 'f');
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_ID */ "f"], 'ch'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* COUNTRIES_FACET_ID */ "m"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DESTINATIONS_FACET_ID */ "w"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"], 's'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* TYPES_OF_STAY_FACET_ID */ "Z"], 't'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$queryPar;

    var activeFacets = ((_queryParams$queryPar = queryParams[queryParamMapping[facetId]]) === null || _queryParams$queryPar === void 0 ? void 0 : _queryParams$queryPar.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"])) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      var facet = decodeURI(activeFacet);

      if (facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
        var _SEASON_FACET_QUERY_P;

        facet = (_SEASON_FACET_QUERY_P = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_EN_TO_FR */ "U"][facet]) !== null && _SEASON_FACET_QUERY_P !== void 0 ? _SEASON_FACET_QUERY_P : facet;
      }

      acc[facet] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});

    if (facet.length && facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
      facet = facet.map(function (label) {
        var _SEASON_FACET_QUERY_P2;

        return (_SEASON_FACET_QUERY_P2 = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_FR_TO_EN */ "V"][label]) !== null && _SEASON_FACET_QUERY_P2 !== void 0 ? _SEASON_FACET_QUERY_P2 : label;
      });
    }

    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, queryParamMapping[facetId], facet.length ? facet.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]) : undefined));
    return facets;
  }, {});
};
var hasDepartureCityAvailable = function hasDepartureCityAvailable(departureCities, departureCity) {
  return departureCities === null || departureCities === void 0 ? void 0 : departureCities.some(function (_ref9) {
    var value = _ref9.value;
    return value === departureCity;
  });
};


/***/ }),

/***/ "lL9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRateType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfirmationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addQueryParameterToCurrentUrl; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Cm4o");
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("hi3+");















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["constants"].PRODUCT_TYPES;
var getRateType = function getRateType(_ref) {
  var isNrrOfferSelected = _ref.isNrrOfferSelected,
      isFlrOfferSelected = _ref.isFlrOfferSelected;

  if (isNrrOfferSelected) {
    return 'non_refundable_rate';
  }

  if (isFlrOfferSelected) {
    return 'flexible_rate';
  }

  return 'standard';
};
var getConfirmationStatus = function getConfirmationStatus(props) {
  var bookingId = props.bookingId,
      _props$config$booking = props.config.booking,
      _props$config$booking2 = _props$config$booking.confirmation,
      bookingCompleteMessage = _props$config$booking2.bookingCompleteMessage,
      bookingByLinkCompleteMessage = _props$config$booking2.bookingByLinkCompleteMessage,
      failure = _props$config$booking2.failure,
      pending = _props$config$booking2.pending,
      headSentence = _props$config$booking2.headSentence,
      fileCreationError = _props$config$booking.banking.error.fileCreationError,
      _props$config$booking3 = _props$config$booking.partners.confirmation,
      bookingCompleteAdditionalText = _props$config$booking3.bookingCompleteAdditionalText,
      partnersHeadSentence = _props$config$booking3.headSentence,
      isSeller = props.isSeller,
      isFromSeller = props.isFromSeller,
      paymentStatus = props.paymentStatus,
      proposal = props.proposal,
      selectedTransfers = props.selectedTransfers,
      donationAmount = props.donationAmount,
      attendeesStatus = props.attendeesStatus;
  var resortName = (proposal === null || proposal === void 0 ? void 0 : proposal.resort.type) === PRODUCT_TYPES.CRUISE ? proposal === null || proposal === void 0 ? void 0 : proposal.resort.title : proposal === null || proposal === void 0 ? void 0 : proposal.resort.name;
  var hasDonation = donationAmount > 0;
  var confirmationStatus = {
    bookingId: bookingId,
    isFromSeller: isFromSeller,
    type: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_TYPE_BOOKING */ "t"],
    attendeesStatus: attendeesStatus
  };

  var getSuccessMessage = function getSuccessMessage() {
    if (isSeller) {
      return bookingCompleteAdditionalText;
    }

    if (isFromSeller) {
      return bookingByLinkCompleteMessage;
    }

    return bookingCompleteMessage;
  };

  switch (paymentStatus) {
    case _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_LABEL_SUCCESS */ "o"].toLowerCase():
      var statusSuccess = {
        donationAmount: donationAmount,
        hasDonation: hasDonation,
        message: getSuccessMessage(),
        status: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_LABEL_SUCCESS */ "o"],
        title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["messageFormat"])(isSeller ? partnersHeadSentence : headSentence).format({
          resortName: resortName
        }),
        shouldDisplayTransferMsg: selectedTransfers.length > 0
      };
      return _objectSpread(_objectSpread({}, confirmationStatus), statusSuccess);

    case _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_REFUSED_CM */ "q"].toLowerCase():
      var statusRefusedCM = {
        message: fileCreationError.confirmationLabel,
        status: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_REFUSED_CM */ "q"],
        title: fileCreationError.confirmationTitle
      };
      return _objectSpread(_objectSpread({}, confirmationStatus), statusRefusedCM);

    case _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_REFUSED_PSP */ "r"].toLowerCase():
      var statusRefusedPSP = {
        message: failure.refusedPSP,
        status: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_REFUSED_PSP */ "r"],
        title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["messageFormat"])(failure.headSentence).format({
          resortName: resortName
        })
      };
      return _objectSpread(_objectSpread({}, confirmationStatus), statusRefusedPSP);

    case _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_PENDING */ "p"].toLowerCase():
      var statusPending = {
        status: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_PENDING */ "p"],
        title: pending.title
      };
      return _objectSpread(_objectSpread({}, confirmationStatus), statusPending);

    default:
      var statusFailure = {
        message: failure.notCompletedMessage,
        status: _utils_payment_constants__WEBPACK_IMPORTED_MODULE_15__[/* PAYMENT_STATUS_LABEL_FAILURE */ "n"],
        title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["messageFormat"])(failure.headSentence).format({
          resortName: resortName
        })
      };
      return _objectSpread(_objectSpread({}, confirmationStatus), statusFailure);
  }
};
var addQueryParameterToCurrentUrl = function addQueryParameterToCurrentUrl(key) {
  var currentUrl = new URL(window.location.href, window.location.origin);
  currentUrl.searchParams.set(key, '');
  window.history.pushState({}, '', currentUrl);
};

/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_CRITERIA_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILDCARE_FILTER_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SEASON_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLIGHT_DURATION_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SORT_BY_PRICE_QUERY_PARAM; });
/* unused harmony export PRODUCTS_TO_COMPARE_QUERY_PARAM */
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOM_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GROUP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHILDCARE_FILTER_FACET_OPTION_0_TO_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHILDCARE_FILTER_FACET_OPTION_2_TO_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHILDCARE_FILTER_FACET_OPTION_4_TO_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHILDCARE_FILTER_FACET_OPTION_11_TO_17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHILDCARE_FILTER_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHILDCARE_FILTER_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FILTER_FACET_AVERAGE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FLIGHT_DURATION_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLIGHT_DURATION_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FLIGHT_DURATION_FACET_AS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SEASON_FACET_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEASON_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEASON_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEASON_FACET_QUERY_PARAM_FR_TO_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SEASON_FACET_QUERY_PARAM_EN_TO_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TYPES_OF_STAY_FACET_BADGE_ICON_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TYPES_OF_STAY_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TYPES_OF_STAY_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
var CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var SEASON_FACET_ID = 'seasons_ns';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_types';
var FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
var QUERY_QUERY_PARAM = 'search';
var SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, CHILDCARE_FILTER_FACET_ID, COUNTRIES_FACET_ID, DESTINATIONS_FACET_ID, SEASON_FACET_ID, TYPES_OF_STAY_FACET_ID];
var CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  trackingPrefixLabel: 'childcare'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  trackingPrefixLabel: 'season'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}];
var GROUP_STRING = 'group::';
var CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = "".concat(GROUP_STRING, "from_0_to_2");
var CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = "".concat(GROUP_STRING, "from_2_to_3");
var CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = "".concat(GROUP_STRING, "from_4_to_10");
var CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = "".concat(GROUP_STRING, "from_11_to_17");
var CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';
var CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "babyClub"),
  from_2_to_3: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "miniClub"),
  from_4_to_10: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "petitClub"),
  from_11_to_17: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "teenClub")
};
var CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168
};
var FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';
var FLIGHT_DURATION_FACET_LABELS = {
  '2h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "2h"),
  '4h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "4h"),
  '8h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h"),
  '8hmore': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h_more")
};
var FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [{
    label: '2h',
    value: '2h',
    count: -1
  }, {
    label: '4h',
    value: '4h',
    count: -1
  }, {
    label: '8h',
    value: '8h',
    count: -1
  }, {
    label: '8hmore',
    value: '8hmore',
    count: -1
  }]
};
var SEASON_FACET_FIRST_OPTION = 'SOLEIL';
var SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';
var SEASON_FACET_LABELS = {
  NEIGE: "".concat(SEASON_FACET_LABELS_PREFIX, "snow"),
  SOLEIL: "".concat(SEASON_FACET_LABELS_PREFIX, "sun")
};
var SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN'
};
var SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL'
};
var NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];
var TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT3
  },
  4: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT4
  },
  5: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].DIAMOND
  },
  6: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT6
  },
  CRUISE: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].CRUISE
  },
  JOYVIEW: {
    className: 'rounded-4 size-40 bg-blueWave border-blueWave text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT_JOYVIEW
  },
  TOUR: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TOUR
  }
};
var TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';
var TYPES_OF_STAY_FACET_LABELS = {
  3: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "3_tridents"),
  4: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "4_tridents"),
  5: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "exclusive_collection"),
  6: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "villa"),
  CRUISE: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "cruise"),
  JOYVIEW: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "joyview"),
  TOUR: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "tour")
};
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.filters.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.filters.where.countriesTitle'
  }],
  titleLabel: 'faceting.filters.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  titleLabel: 'faceting.filters.activities.title'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  dataLabel: 'childcare',
  facetLists: [{
    deep: false,
    id: CHILDCARE_FILTER_FACET_ID,
    facetLabels: CHILDCARE_FILTER_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.childcare.title',
  trackingPrefixLabel: 'childcare'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: TYPES_OF_STAY_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  dataLabel: 'flightDuration',
  facetLists: [{
    deep: false,
    id: FLIGHT_DURATION_FACET_ID,
    facetLabels: FLIGHT_DURATION_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.flightDuration.title',
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  capitalizeLabels: true,
  dataLabel: 'season',
  facetLists: [{
    deep: false,
    id: SEASON_FACET_ID,
    facetLabels: SEASON_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.season.title',
  trackingPrefixLabel: 'season'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "suq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ConfirmationView_ConfirmationView; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/widgets/product-introduction-actions/ProductIntroductionActions.jsx
var ProductIntroductionActions = __webpack_require__("6Jj1");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx + 1 modules
var ProductLogo = __webpack_require__("hA0C");

// EXTERNAL MODULE: ./src/client/components/widgets/copy-button/CopyButton.jsx
var CopyButton = __webpack_require__("wKck");

// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction-lite/ProductIntroductionLite.jsx



var __jsx = react_default.a.createElement;
















var ProductIntroductionLite_ProductIntroductionLite = function ProductIntroductionLite(_ref) {
  var bookingId = _ref.bookingId,
      className = _ref.className,
      cta = _ref.cta,
      description = _ref.description,
      iconName = _ref.iconName,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isPaymentSuccess = _ref.isPaymentSuccess,
      imageSrc = _ref.imageSrc,
      onClickCopyPaste = _ref.onClickCopyPaste,
      onClickLogin = _ref.onClickLogin,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      ratingImage = _ref.ratingImage,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged,
      isQuickLogged = _useAuthentication.isQuickLogged;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var loginUrl = isLogged || isQuickLogged ? routeBuilder["a" /* buildUrl */]('account') : ple_utils["f" /* buildSigninUrl */]({
    locale: appContext.locale,
    isQuickLoginFirst: true
  });

  var copyBookingId = function copyBookingId() {
    navigator.clipboard.writeText(bookingId ? bookingId : '');
  };

  var top = __jsx("div", {
    className: "relative inset-x-0 -top-[6.25rem] z-1 mx-auto -mb-100 w-160 rounded-12 bg-white p-15 pt-20 shadow-subtle lg:absolute lg:-top-[3.75rem] lg:mb-0 lg:w-180"
  }, __jsx(ProductLogo["a" /* ProductLogo */], {
    iconName: iconName === null || iconName === void 0 ? void 0 : iconName.slice(0, 4),
    isExclusiveCollection: isExclusiveCollection,
    productCountry: productCountry,
    productName: productName
  }), __jsx(ProductIntroductionActions["a" /* ProductIntroductionActions */], {
    ratingImage: ratingImage
  }));

  return isDesktop ? __jsx("article", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate my-60 pt-20', className),
    "data-testid": "product-introduction-lite"
  }, top, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex', {
      'justify-center': !isPaymentSuccess
    })
  }, __jsx("div", {
    className: "relative z-0 w-1/2 overflow-hidden rounded-12"
  }, __jsx(Image["a" /* Image */], {
    imageUrl: imageSrc,
    dimensions: {
      w: 580,
      h: 580
    }
  })), isPaymentSuccess && __jsx("div", {
    className: "relative flex w-1/2 flex-col justify-center py-60"
  }, __jsx("p", {
    className: "ms-auto flex w-5/6 items-center gap-15 ps-20 font-brand text-24"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEOPLE,
    width: "1.875rem"
  }), title), __jsx("p", {
    className: "mb-30 ms-100 mt-0 w-380 ps-20"
  }, description), !isLogged && __jsx("div", {
    className: "mb-30 flex items-center"
  }, __jsx("p", {
    className: "me-20 ms-100 ps-20 font-brand text-sienna"
  }, bookingId), __jsx(CopyButton["a" /* CopyButton */], {
    onClick: function onClick() {
      copyBookingId();
      onClickCopyPaste === null || onClickCopyPaste === void 0 ? void 0 : onClickCopyPaste();
    }
  }, Object(i18n["h" /* t */])('booking.common.copyPaste'))), __jsx("div", {
    className: "ms-auto w-5/6 ps-20"
  }, __jsx(Button["a" /* Button */], {
    className: "self-start",
    onClick: onClickLogin,
    size: "medium",
    isExternalLink: true,
    target: "_blank",
    url: loginUrl
  }, cta))))) : __jsx("article", {
    className: className,
    "data-testid": "product-introduction-lite"
  }, __jsx("div", {
    className: "mb-40 pt-20"
  }, __jsx("div", {
    className: "mx-auto max-w-400 overflow-hidden rounded-12"
  }, __jsx(Image["a" /* Image */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].SQUARE
  })), top), isPaymentSuccess && __jsx("div", {
    className: "mb-80 flex flex-col items-center"
  }, __jsx(Icon["a" /* Icon */], {
    className: "p-3",
    name: icons["a" /* ICONS */].PEOPLE,
    width: "1.875rem"
  }), __jsx("div", {
    className: "flex items-center"
  }, __jsx("p", {
    className: "font-brand text-24",
    "data-testid": "product-introduction-lite-title"
  }, title)), __jsx("p", {
    className: "mb-30 mt-0 items-center text-center"
  }, description), !isLogged && __jsx("div", {
    className: "mb-30"
  }, __jsx("p", {
    className: "text-center font-brand text-sienna"
  }, bookingId), __jsx("div", {
    className: "flex items-center gap-10"
  }, __jsx(CopyButton["a" /* CopyButton */], {
    onClick: function onClick() {
      copyBookingId();
      onClickCopyPaste === null || onClickCopyPaste === void 0 ? void 0 : onClickCopyPaste();
    }
  }, Object(i18n["h" /* t */])('booking.common.copyPaste')))), __jsx("div", null, __jsx(Button["a" /* Button */], {
    className: "self-start",
    onClick: onClickLogin,
    size: "medium",
    url: loginUrl
  }, cta))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: ./src/client/components/widgets/accordion-block/AccordionBlock.jsx
var AccordionBlock = __webpack_require__("sORq");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-summary/AccommodationSummary.jsx
var AccommodationSummary = __webpack_require__("g5cf");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// EXTERNAL MODULE: ./src/client/components/widgets/stay-summary-ticket/Breadcrumb.module.css
var Breadcrumb_module = __webpack_require__("iNQX");
var Breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumb_module);

// CONCATENATED MODULE: ./src/client/components/widgets/stay-summary-ticket/PriceDetails.jsx


var PriceDetails_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */
















var PriceDetails_DiscountsLineConfirmation = function DiscountsLineConfirmation(_ref) {
  var discounts = _ref.discounts;

  if (!discounts) {
    return null;
  }

  return PriceDetails_jsx("div", {
    className: "mb-15 border-b-1 border-solid pb-15"
  }, discounts.map(function (_ref2) {
    var offerName = _ref2.offerName,
        offerColor = _ref2.offerColor,
        _ref2$amount = _ref2.amount,
        amountFormattedValue = _ref2$amount.formattedValue,
        value = _ref2$amount.value;

    if (!amountFormattedValue) {
      return null;
    }

    var secureOfferName = offerName || Object(i18n["h" /* t */])('booking.summary.discount.discountLabel');
    return PriceDetails_jsx("div", {
      className: "flex justify-between text-14",
      key: offerName + value + '-discount',
      style: {
        color: offerColor
      }
    }, PriceDetails_jsx("p", null, secureOfferName), "- ", amountFormattedValue);
  }));
};

var PriceDetails_PriceDetails = function PriceDetails(_ref3) {
  var _proposal$price, _proposal$price$insur, _proposal$price2, _proposal$price2$insu, _proposal$price$fees, _touristicTaxes$amoun, _proposal$price$fees2, _portTaxes$amount, _annualCotisation$amo;

  var proposal = _ref3.proposal,
      isOptionPaymentMethod = _ref3.isOptionPaymentMethod,
      optionDuration = _ref3.optionDuration,
      isPaymentFailure = _ref3.isPaymentFailure,
      isPaymentFailureCM = _ref3.isPaymentFailureCM,
      isPaymentFailurePSP = _ref3.isPaymentFailurePSP,
      isOptionFailure = _ref3.isOptionFailure;
  var FLEX_RATES = dist["constants"].FLEX_RATES;
  var annualCotisation = proposal.price.fees.find(function (fee) {
    return fee.type === 'SUBSCRIPTION';
  });
  var insuranceValue = proposal.price.insurance === undefined || ((_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$insur = _proposal$price.insurance) === null || _proposal$price$insur === void 0 ? void 0 : _proposal$price$insur.value) === null ? null : (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$insu = _proposal$price2.insurance) === null || _proposal$price2$insu === void 0 ? void 0 : _proposal$price2$insu.formattedValue;
  var touristicTaxes = (_proposal$price$fees = proposal.price.fees) === null || _proposal$price$fees === void 0 ? void 0 : _proposal$price$fees.find(function (fee) {
    return fee.type === priceTicket_constants["d" /* TOURISTIC_TAXES */];
  });
  var touristicTaxesValue = touristicTaxes === null || touristicTaxes === void 0 ? void 0 : (_touristicTaxes$amoun = touristicTaxes.amount) === null || _touristicTaxes$amoun === void 0 ? void 0 : _touristicTaxes$amoun.formattedValue;
  var portTaxes = (_proposal$price$fees2 = proposal.price.fees) === null || _proposal$price$fees2 === void 0 ? void 0 : _proposal$price$fees2.find(function (fee) {
    return fee.type === priceTicket_constants["a" /* PORT_TAXES */];
  });
  var portTaxesValue = portTaxes === null || portTaxes === void 0 ? void 0 : (_portTaxes$amount = portTaxes.amount) === null || _portTaxes$amount === void 0 ? void 0 : _portTaxes$amount.formattedValue;
  var annualCotisationValue = annualCotisation === null || annualCotisation === void 0 ? void 0 : (_annualCotisation$amo = annualCotisation.amount) === null || _annualCotisation$amo === void 0 ? void 0 : _annualCotisation$amo.formattedValue;

  var _useState = Object(react["useState"])(false),
      isPriceDetailsOpened = _useState[0],
      setIsPriceDetailsOpened = _useState[1];

  var paymentMethod = js_cookie_default.a.get(PaymentInfo_const["m" /* PAYMENT_METHOD_LABEL */]);
  var hasSelectedSeveralPayments = !!js_cookie_default.a.get(BookingEngine_utils["a" /* SVRL_PMNTS */]); // && we're in good proposal (proposal router === proposal cookie) ;

  var hasPaymentError = isPaymentFailure || isPaymentFailureCM || isPaymentFailurePSP;
  var depositAmount = proposal.households[0].paymentSchedule.depositAmount.formattedValue;
  var deadline = proposal.households[0].paymentSchedule.repaymentSchedules.map(function (el) {
    return el.deadline;
  });
  var formattedDeadline = Object(apiDate["j" /* momentFromApiDate */])(deadline[0]).format('LL');
  var remainingAmount = proposal.households[0].paymentSchedule.repaymentSchedules.map(function (el) {
    return el.amount.formattedValue;
  });

  var getSelectedRate = function getSelectedRate(selectedRate) {
    if (selectedRate === FLEX_RATES.NRR) {
      return Object(i18n["h" /* t */])('booking.accommodation.stickyPrice.nonRefundableRateLabel');
    }

    if (selectedRate === FLEX_RATES.FLR) {
      return Object(i18n["h" /* t */])('booking.accommodation.stickyPrice.flexibleRateLabel');
    }

    return Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLabel');
  };

  var displayPaymentMethod = function displayPaymentMethod() {
    if (hasPaymentError || !paymentMethod) {
      return null;
    }

    if (!hasPaymentError) {
      return PriceDetails_jsx("p", {
        className: "text-14"
      }, Object(i18n["h" /* t */])('booking.confirmation.paymentMethodUsed', {
        paymentMethod: paymentMethod
      }));
    }
  };

  var displayPaidLabel = function displayPaidLabel() {
    if (hasPaymentError || hasSelectedSeveralPayments) {
      return null;
    }

    if (!hasSelectedSeveralPayments && !hasPaymentError) {
      return PriceDetails_jsx("div", {
        className: "flex gap-5"
      }, PriceDetails_jsx(Icon["a" /* Icon */], {
        className: "text-emerald",
        name: icons["a" /* ICONS */].CHECK_FILLED,
        width: "1.5rem"
      }), PriceDetails_jsx("p", {
        className: "text-emerald text-right font-bold"
      }, Object(i18n["h" /* t */])('stays.statusLabels.paidLabel')));
    }
  };

  var displaySeveralInstalments = function displaySeveralInstalments() {
    if (hasPaymentError) {
      return null;
    }

    if (hasSelectedSeveralPayments) {
      return PriceDetails_jsx("div", {
        className: "mt-15 flex justify-between rounded-12 border-1 border-solid border-sienna p-20"
      }, PriceDetails_jsx("p", {
        className: "text-14 font-bold"
      }, Object(i18n["h" /* t */])('booking.confirmation.paymentDepositLabel')), PriceDetails_jsx("div", {
        className: Breadcrumb_module_default.a.breadcrumb
      }, PriceDetails_jsx("ul", {
        className: Breadcrumb_module_default.a.list
      }, PriceDetails_jsx("li", {
        className: "text-emerald text-right text-14 font-bold"
      }, PriceDetails_jsx("span", null, Object(i18n["h" /* t */])('booking.confirmation.today')), PriceDetails_jsx("br", null), PriceDetails_jsx("span", null, depositAmount)), PriceDetails_jsx("li", {
        className: "text-right text-14 font-bold"
      }, PriceDetails_jsx("span", null, Object(i18n["h" /* t */])('booking.confirmation.paymentBalanceDate', {
        balanceDate: formattedDeadline
      }), PriceDetails_jsx("br", null), PriceDetails_jsx("span", null, remainingAmount))))));
    }
  };

  return PriceDetails_jsx("div", {
    className: "border-t-1 border-dashed pt-15"
  }, PriceDetails_jsx("div", {
    className: "my-20 flex justify-between"
  }, PriceDetails_jsx("p", {
    className: "font-bold"
  }, Object(i18n["h" /* t */])('booking.confirmation.priceDetail')), PriceDetails_jsx("button", {
    "data-testid": "price-details-button",
    type: "button",
    onClick: function onClick() {
      return setIsPriceDetailsOpened(!isPriceDetailsOpened);
    }
  }, PriceDetails_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: isPriceDetailsOpened ? 0 : 180
  }))), PriceDetails_jsx(lib["UnmountClosed"], {
    isOpened: isPriceDetailsOpened
  }, PriceDetails_jsx("div", {
    className: "mb-15 border-b-1 border-solid pb-15"
  }, PriceDetails_jsx(PriceDetails_DiscountsLineConfirmation, {
    discounts: proposal.price.discounts
  }), annualCotisation && PriceDetails_jsx("div", {
    className: "mt-10 flex justify-between text-14"
  }, PriceDetails_jsx("div", {
    className: "flex"
  }, PriceDetails_jsx("p", {
    className: ""
  }, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.annualMembershipFeesLabel')), PriceDetails_jsx(Tooltip["a" /* Tooltip */], {
    modalProps: {
      closeLabel: Object(i18n["h" /* t */])('common.close'),
      size: 'small',
      children: null
    },
    renderTrigger: function renderTrigger(toggle) {
      return PriceDetails_jsx("button", {
        className: "mx-5",
        onClick: toggle,
        type: "button"
      }, PriceDetails_jsx(Icon["a" /* Icon */], {
        className: "text-blue",
        name: icons["a" /* ICONS */].INFORMATION,
        width: "1.2rem"
      }));
    }
  }, PriceDetails_jsx("div", {
    className: "p-20"
  }, PriceDetails_jsx(Text["a" /* Text */], {
    className: "mb-10 text-12",
    text: Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.annualFeesInformation')
  })))), "+ ", annualCotisationValue), touristicTaxes && PriceDetails_jsx("div", {
    className: "mt-10 flex justify-between text-14"
  }, PriceDetails_jsx("div", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.touristicTaxesLabel')), "+\xA0", touristicTaxesValue), portTaxes && PriceDetails_jsx("div", {
    className: "mt-10 flex justify-between text-14"
  }, PriceDetails_jsx("div", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.portTaxesLabel')), "+\xA0", portTaxesValue), insuranceValue && PriceDetails_jsx("div", {
    className: "mt-10 flex justify-between text-14"
  }, PriceDetails_jsx("div", null, Object(i18n["h" /* t */])('booking.insurance.insuranceLabel')), "+ ", insuranceValue)), PriceDetails_jsx("div", {
    className: "mb-10 mt-15 flex justify-between"
  }, PriceDetails_jsx("div", {
    className: "flex flex-col text-14"
  }, PriceDetails_jsx("p", {
    className: "font-bold"
  }, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')), Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) && PriceDetails_jsx("p", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel'))), PriceDetails_jsx("div", null, PriceDetails_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('text-18', {
      'text-emerald': !isOptionPaymentMethod
    })
  }, proposal.price.total.formattedValue))), !isOptionPaymentMethod && PriceDetails_jsx(react_default.a.Fragment, null, PriceDetails_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex', {
      'justify-between': paymentMethod,
      'justify-end': !paymentMethod
    })
  }, displayPaymentMethod(), displayPaidLabel()), displaySeveralInstalments(), proposal.price.hasFlexRates && proposal.price.selectedRate && PriceDetails_jsx("div", {
    className: "mt-15 flex justify-end"
  }, PriceDetails_jsx("div", {
    className: "rounded-12 bg-sienna p-5 text-12 font-bold text-white"
  }, getSelectedRate(proposal.price.selectedRate)))), isOptionPaymentMethod && PriceDetails_jsx("div", {
    className: "flex items-start justify-between text-14"
  }, !isOptionFailure && PriceDetails_jsx(react_default.a.Fragment, null, PriceDetails_jsx("p", {
    className: "flex-1"
  }, Object(i18n["h" /* t */])('booking.option.confirmation.optionDuration', {
    duration: optionDuration
  })), PriceDetails_jsx("div", {
    className: "flex items-center gap-5"
  }, PriceDetails_jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    name: icons["a" /* ICONS */].CALENDAR_OPTION,
    width: "1.5rem"
  }), PriceDetails_jsx("p", {
    className: "font-bold text-sienna"
  }, Object(i18n["h" /* t */])('booking.confirmation.optionValidated')))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/stay-summary-ticket/StaySummaryTicket.utils.js
var StaySummaryTicket_utils = __webpack_require__("s2zd");

// CONCATENATED MODULE: ./src/client/components/widgets/stay-summary-ticket/StaySummaryTicket.jsx


var StaySummaryTicket_jsx = react_default.a.createElement;







var StaySummaryTicket_StaySummaryTicket = function StaySummaryTicket(_ref) {
  var proposal = _ref.proposal,
      isOptionPaymentMethod = _ref.isOptionPaymentMethod,
      optionDuration = _ref.optionDuration,
      isPaymentFailure = _ref.isPaymentFailure,
      isPaymentFailureCM = _ref.isPaymentFailureCM,
      isPaymentFailurePSP = _ref.isPaymentFailurePSP,
      isOptionFailure = _ref.isOptionFailure;
  var context = Object(react["useContext"])(ReactAppContext["a" /* B2CAppContext */]);
  var roomQuantity = proposal.accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
  return StaySummaryTicket_jsx("div", {
    className: "mb-100 rounded-12 bg-white p-20 shadow-sm",
    "data-testid": "stay-summary-ticket"
  }, StaySummaryTicket_jsx(AccordionBlock["a" /* AccordionBlock */], {
    trackingEventName: tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_STAY_DETAILS,
    lines: Object(StaySummaryTicket_utils["a" /* getStaySummaryLinesByProposal */])({
      accommodationSummary: StaySummaryTicket_jsx(AccommodationSummary["a" /* AccommodationSummary */], {
        accommodations: proposal.accommodations,
        resort: proposal.resort,
        roomQuantity: roomQuantity
      }),
      locale: context.locale,
      proposal: proposal
    })
  }), StaySummaryTicket_jsx(PriceDetails_PriceDetails, {
    proposal: proposal,
    isOptionPaymentMethod: isOptionPaymentMethod,
    optionDuration: optionDuration,
    isPaymentFailure: isPaymentFailure,
    isPaymentFailureCM: isPaymentFailureCM,
    isPaymentFailurePSP: isPaymentFailurePSP,
    isOptionFailure: isOptionFailure
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/inspirational-grid/descriptor.js + 9 modules
var descriptor = __webpack_require__("3Fn9");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/views/account/queries/account.queries.js
var account_queries = __webpack_require__("QRI5");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/use-gql-errors-handler/useGQLErrorsHandler.js
var useGQLErrorsHandler = __webpack_require__("Kl3I");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/widgets/stay-share/StayShare.jsx + 2 modules
var StayShare = __webpack_require__("mdL+");

// CONCATENATED MODULE: ./src/client/components/widgets/stay-share/StayShareContainer.jsx

var StayShareContainer_jsx = react_default.a.createElement;



var StayShareContainer_StayShareContainer = function StayShareContainer(props) {
  return StayShareContainer_jsx("div", {
    className: "mt-100"
  }, StayShareContainer_jsx("p", {
    className: "font-brand text-32 text-center"
  }, Object(i18n["h" /* t */])('booking.confirmation.shareMyTripTitle')), StayShareContainer_jsx("div", {
    className: "flex justify-between items-center mt-100 mb-100 bg-white rounded-2 shadow-sm px-20 py-30 sm:ms-100"
  }, StayShareContainer_jsx("div", {
    className: ""
  }, StayShareContainer_jsx("p", {
    className: "font-brand text-24 mb-10"
  }, Object(i18n["h" /* t */])('common.stays.sharemytrip.popin.title')), StayShareContainer_jsx("p", {
    className: "text-14"
  }, Object(i18n["h" /* t */])('booking.confirmation.shareMyTripDescription'))), StayShareContainer_jsx(StayShare["a" /* StayShare */], Object(esm_extends["a" /* default */])({}, props, {
    isBE: true
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/useUpliftConfirmation.js
var useUpliftConfirmation = __webpack_require__("JRz1");

// EXTERNAL MODULE: ./src/client/components/widgets/push-app-banner/PushAppBanner.jsx + 1 modules
var PushAppBanner = __webpack_require__("6Wi6");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/views/booking/confirmation/header/ConfirmationHeader.utils.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var ConfirmationHeader_utils_getBookingStatusIcon = function getBookingStatusIcon(status) {
  var defaultIcon = {
    color: colors["a" /* COLORS */].RED,
    icon: icons["a" /* ICONS */].CROSS_OUTLINE
  };
  var customIcon;

  switch (status) {
    case constants["n" /* PAYMENT_STATUS_LABEL_FAILURE */]:
      customIcon = _objectSpread({}, defaultIcon);
      break;

    case constants["q" /* PAYMENT_STATUS_REFUSED_CM */]:
      customIcon = {
        color: defaultIcon.color,
        icon: icons["a" /* ICONS */].WARNING
      };
      break;

    case constants["r" /* PAYMENT_STATUS_REFUSED_PSP */]:
      customIcon = {
        color: defaultIcon.color,
        icon: defaultIcon.icon
      };
      break;

    default:
      customIcon = {
        color: colors["a" /* COLORS */].GREEN,
        icon: icons["a" /* ICONS */].CHECK_OUTLINE
      };
      break;
  }

  return customIcon;
};
// CONCATENATED MODULE: ./src/client/views/booking/confirmation/header/ConfirmationHeader.jsx
var ConfirmationHeader_jsx = react_default.a.createElement;





var ConfirmationHeader_ConfirmationHeader = function ConfirmationHeader(props) {
  var status = props.status,
      title = props.title;
  var customIcon = ConfirmationHeader_utils_getBookingStatusIcon(status);
  return ConfirmationHeader_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-start gap-10 font-brand text-32 leading-1 md:items-center md:text-44', {
      'text-red': status === constants["q" /* PAYMENT_STATUS_REFUSED_CM */]
    }),
    "data-testid": "ConfirmationHeader-".concat(customIcon.icon)
  }, ConfirmationHeader_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-".concat(customIcon.color),
    name: customIcon.icon,
    width: "1.5em"
  }), title);
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("Jhhs");

// CONCATENATED MODULE: ./src/client/views/booking/confirmation/header/MultiHouseholdsPaidConfirmationHeader.jsx



var MultiHouseholdsPaidConfirmationHeader_jsx = react_default.a.createElement;








var MultiHouseholdsPaidConfirmationHeader_MultiHouseholdsPaidConfirmationHeader = function MultiHouseholdsPaidConfirmationHeader(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var status = props.status,
      attendee = props.attendee,
      _props$householdId = props.householdId,
      householdId = _props$householdId === void 0 ? 0 : _props$householdId;
  var customIcon = ConfirmationHeader_utils_getBookingStatusIcon(status);
  return MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('ConfirmationHeader', {
      'mb-15 flex items-center gap-20': appContext.isCxo
    }),
    "data-testid": "ConfirmationHeader-".concat(customIcon.icon)
  }, MultiHouseholdsPaidConfirmationHeader_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "2em"
  }), MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    className: "flex flex-col gap-10"
  }, MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    id: "attendee"
  }, MultiHouseholdsPaidConfirmationHeader_jsx("p", {
    className: "text-xl mb-0 font-brand"
  }, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.householdNumber', {
    householdNnumber: (householdId + 1).toString().padStart(2, '0')
  })), attendee && MultiHouseholdsPaidConfirmationHeader_jsx("p", {
    className: "text-3xl mt-0 font-brand"
  }, attendee.firstName, " ", attendee.lastName)), MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    id: "success-message"
  }, MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    className: "leading-one text-11xl mt-0 font-brand text-sienna"
  }, Object(i18n["h" /* t */])('booking.common.success')), MultiHouseholdsPaidConfirmationHeader_jsx("div", {
    className: "text-xl mt-0"
  }, Object(i18n["h" /* t */])('booking.partners.confirmation.bookingCompleteAdditionalText')))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/views/booking/confirmation/DonationThanks.jsx
var DonationThanks_jsx = react["createElement"];





var DonationThanks_DonationThanks = function DonationThanks(_ref) {
  var isMobile = _ref.isMobile;
  return DonationThanks_jsx(Notification["a" /* Notification */], {
    className: Object(classnames_utils["a" /* classnames */])('text-14', 'font-bold', {
      'mb-20': !isMobile
    }, {
      'mt-20': isMobile
    }),
    iconName: icons["a" /* ICONS */].DONATION,
    iconWidth: "1.5rem"
  }, DonationThanks_jsx("div", {
    className: "p-5"
  }, DonationThanks_jsx("span", null, Object(i18n["h" /* t */])('booking.confirmation.donationSentence')), "\xA0", DonationThanks_jsx("a", {
    className: "underline",
    href: Object(i18n["h" /* t */])('booking.confirmation.donationLinkURL'),
    target: "blank"
  }, Object(i18n["h" /* t */])('booking.confirmation.donationLinkLabel'))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pickBy.js
var pickBy = __webpack_require__("f9bD");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// CONCATENATED MODULE: ./src/client/views/booking/confirmation/header/UnpaidHouseholdConfirmationHeader.jsx















var UnpaidHouseholdConfirmationHeader_jsx = react_default.a.createElement;

function UnpaidHouseholdConfirmationHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UnpaidHouseholdConfirmationHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UnpaidHouseholdConfirmationHeader_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UnpaidHouseholdConfirmationHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 // $FlowFixMe








var UnpaidHouseholdConfirmationHeader_UnpaidHouseholdConfirmationHeader = function UnpaidHouseholdConfirmationHeader(props) {
  var bookingId = props.bookingId,
      proposal = props.proposal,
      householdId = props.householdId,
      attendee = props.attendee;
  var router = Object(next_router["useRouter"])();
  var sellerParameters = Object.keys(dist["appQueryParameters"].cxo).concat(Object.keys(dist["appQueryParameters"].cmta));
  var bankingPageUri = routeBuilder["a" /* buildUrl */]('b2bBookingPrePayment', {
    proposalId: proposal.id
  }, UnpaidHouseholdConfirmationHeader_objectSpread({
    bookingId: bookingId
  }, pickBy_default()(router.query, function (value, key) {
    return sellerParameters.includes(key);
  })));
  return UnpaidHouseholdConfirmationHeader_jsx("div", {
    className: "flex items-center gap-20"
  }, UnpaidHouseholdConfirmationHeader_jsx(Icon["a" /* Icon */], {
    className: "text-orange",
    name: icons["a" /* ICONS */].CIRCLED_RIGHT_ARROW,
    width: "2em"
  }), UnpaidHouseholdConfirmationHeader_jsx("div", {
    className: "flex flex-col gap-10"
  }, UnpaidHouseholdConfirmationHeader_jsx("div", null, UnpaidHouseholdConfirmationHeader_jsx("p", {
    className: "text-xl mb-0 font-brand"
  }, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.householdNumber', {
    householdNnumber: (householdId + 1).toString().padStart(2, '0')
  })), attendee && UnpaidHouseholdConfirmationHeader_jsx("p", {
    className: "text-3xl mt-0 font-brand"
  }, attendee.firstName, " ", attendee.lastName)), UnpaidHouseholdConfirmationHeader_jsx("div", null, UnpaidHouseholdConfirmationHeader_jsx("div", null, UnpaidHouseholdConfirmationHeader_jsx(Button["a" /* Button */], {
    onClick: function onClick() {
      return router.push(bankingPageUri);
    },
    size: "small"
  }, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.bookingLabel'))))));
};
// CONCATENATED MODULE: ./src/client/views/booking/confirmation/ConfirmationView.utils.js

var ConfirmationView_utils_getAdequateInfosForBookingOrOption = function getAdequateInfosForBookingOrOption(isOptionPaymentMethod, isLogged) {
  if (isOptionPaymentMethod) {
    if (!isLogged) {
      return {
        title: Object(i18n["h" /* t */])('booking.confirmation.quickLogin'),
        description: Object(i18n["h" /* t */])('booking.option.quickLoginDescription'),
        cta: Object(i18n["h" /* t */])('booking.option.quickAccountAccess')
      };
    }

    return {
      title: Object(i18n["h" /* t */])('booking.confirmation.accountAccess'),
      description: Object(i18n["h" /* t */])('booking.option.accountAccessDescription'),
      cta: Object(i18n["h" /* t */])('booking.option.accountAccess')
    };
  }

  if (!isLogged) {
    return {
      title: Object(i18n["h" /* t */])('booking.confirmation.quickLogin'),
      description: Object(i18n["h" /* t */])('booking.confirmation.quickLoginDescription'),
      cta: Object(i18n["h" /* t */])('booking.confirmation.quickAccountAccess')
    };
  }

  return {
    title: Object(i18n["h" /* t */])('booking.confirmation.accountAccess'),
    description: Object(i18n["h" /* t */])('booking.confirmation.accountAccessDescription'),
    cta: Object(i18n["h" /* t */])('booking.confirmation.accountAccess')
  };
};
// CONCATENATED MODULE: ./src/client/views/booking/confirmation/ConfirmationMessage.jsx
var ConfirmationMessage_jsx = react_default.a.createElement;









var ConfirmationMessage_ConfirmationMessage = function ConfirmationMessage(_ref) {
  var isVisibleSalesmanIDWarningMessage = _ref.isVisibleSalesmanIDWarningMessage,
      message = _ref.message,
      status = _ref.status,
      type = _ref.type;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isRefusedCMPayment = status === constants["q" /* PAYMENT_STATUS_REFUSED_CM */];
  var isSalesmanIDEnabledForCmta = appContext.isCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cmta.salesmanID');
  var salesmanIDWarningMessage = type === 'OPTION' ? Object(i18n["h" /* t */])('booking.partners.participants.salesmanIDWarningMessageOption') : Object(i18n["h" /* t */])('booking.partners.participants.salesmanIDWarningMessage');
  var stat = status.toLowerCase();
  return ConfirmationMessage_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'text-red': stat === 'failure' || stat === 'refused_psp',
      'text-success': stat === 'success'
    }),
    "data-testid": "ConfirmationMessage--".concat(stat)
  }, ConfirmationMessage_jsx("span", null, message, isRefusedCMPayment && ConfirmationMessage_jsx("span", {
    className: "mx-5 text-saffron"
  }, ConfirmationMessage_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE
  }), " ", Object(i18n["h" /* t */])('booking.counterProposalPopIn.callCenterNumber'))), isSalesmanIDEnabledForCmta && isVisibleSalesmanIDWarningMessage && ConfirmationMessage_jsx(Notification["a" /* Notification */], {
    className: "bg-transparent text-red",
    iconName: icons["a" /* ICONS */].WARNING,
    iconWidth: "1rem",
    title: salesmanIDWarningMessage
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/confirmation/ConfirmationView.jsx








var ConfirmationView_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








































var ConfirmationView_ConfirmationHeaderWrapper = function ConfirmationHeaderWrapper(_ref) {
  var proposal = _ref.proposal,
      attendeesStatus = _ref.attendeesStatus,
      isOptionPaymentMethod = _ref.isOptionPaymentMethod,
      title = _ref.title,
      status = _ref.status,
      bookingId = _ref.bookingId;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var shouldDisplayOnlyOneHousehold = proposal.households.length === 1 || // GM confirmation of a voxpay payment
  !appContext.isSeller;

  if (shouldDisplayOnlyOneHousehold) {
    return ConfirmationView_jsx(ConfirmationHeader_ConfirmationHeader, {
      key: "ConfirmationHeader_".concat(proposal.households[0].attendees[0].customerId || ''),
      status: status,
      title: title
    });
  }

  return proposal.households.map(function (household, index) {
    var mainAttendeeId = household.attendees[0].customerId || '';

    var _ref2 = attendeesStatus.find(function (attendeeStatus) {
      return attendeeStatus.customerId === mainAttendeeId;
    }) || {
      hasPaid: false
    },
        hasPaid = _ref2.hasPaid;

    var shoudDisplayConfirmationHeader = isOptionPaymentMethod || hasPaid;
    return shoudDisplayConfirmationHeader ? ConfirmationView_jsx(MultiHouseholdsPaidConfirmationHeader_MultiHouseholdsPaidConfirmationHeader, {
      key: "ConfirmationHeader_".concat(mainAttendeeId),
      title: title,
      status: status,
      attendee: Object(proposalUtils["h" /* getMainHouseholdAttendee */])(proposal, index),
      isOptionPaymentMethod: true,
      householdId: index
    }) : ConfirmationView_jsx(UnpaidHouseholdConfirmationHeader_UnpaidHouseholdConfirmationHeader, {
      key: "ConfirmationHeader_".concat(mainAttendeeId),
      bookingId: bookingId,
      proposal: proposal,
      householdId: index,
      attendee: Object(proposalUtils["h" /* getMainHouseholdAttendee */])(proposal, index)
    });
  });
};

var ConfirmationView_ConfirmationView = function ConfirmationView(_ref3) {
  var _proposal$resort$imag;

  var confirmation = _ref3.confirmation,
      proposal = _ref3.proposal;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isTablet = _useResponsive.isTablet;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useRouter = Object(next_router["useRouter"])(),
      query = _useRouter.query;

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var isExclusiveCollection = proposal.accommodations[0].exclusiveCollection;
  var _proposal$resort = proposal.resort,
      productId = _proposal$resort.id,
      isJoyview = _proposal$resort.isJoyview;
  var hasPackage = Boolean(isJoyview && productId);
  var title = confirmation.title,
      status = confirmation.status,
      bookingId = confirmation.bookingId,
      hasDonation = confirmation.hasDonation,
      type = confirmation.type,
      message = confirmation.message;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    cache: true,
    ignore: !isLogged,
    query: Object(account_queries["e" /* getCustomerBookingAttendeesQuery */])({
      bookingId: bookingId,
      isJoyview: isJoyview,
      productId: productId,
      withPackage: hasPackage
    }),
    queryOptions: {
      cacheFront: {
        key: (hasPackage ? '_WITH_UPSELL_PACKAGE' : '') + productId + bookingId
      },
      requestName: requestDictionary["N" /* CUSTOMER_BOOKING_GET_ATTENDEES */] + (hasPackage ? '_WITH_UPSELL_PACKAGE' : '')
    },
    map: function map(_ref4) {
      var customerBooking = _ref4.customerBooking;
      return (customerBooking === null || customerBooking === void 0 ? void 0 : customerBooking.attendees) || [];
    }
  }),
      data = _useGQL.data,
      error = _useGQL.error;

  Object(useGQLErrorsHandler["a" /* useGQLErrorsHandler */])(error, {
    catchAuthError: true
  });
  var booking = {
    bookingId: bookingId,
    arrivalDate: proposal.departureDate,
    departureDate: proposal.arrivalDate,
    name: proposal.productId,
    accommodations: {
      count: proposal.accommodationsCount,
      name: proposal.accommodations[0].category
    },
    price: proposal.price.total.value,
    transport: [],
    attendees: proposal.attendees.list.map(function (_ref5) {
      var customerId = _ref5.customerId;
      return customerId;
    })
  };
  var duration = Object(react["useMemo"])(function () {
    return confirmation.expirationTime ? Object(apiDate["i" /* getDiffFromNowTo */])(confirmation.expirationTime) : '';
  }, [apiDate["i" /* getDiffFromNowTo */], confirmation]);
  var disclaimer = confirmation.isReliable === 'false' ? Object(i18n["h" /* t */])('booking.option.DurationDisclaimer') : '';
  var isPaymentSuccess = status === constants["o" /* PAYMENT_STATUS_LABEL_SUCCESS */];
  var isPaymentFailureCM = status === constants["q" /* PAYMENT_STATUS_REFUSED_CM */];
  var isPaymentFailurePSP = status === constants["r" /* PAYMENT_STATUS_REFUSED_PSP */];
  var isPaymentPending = status === constants["p" /* PAYMENT_STATUS_PENDING */];
  var isPaymentFailure = status === constants["n" /* PAYMENT_STATUS_LABEL_FAILURE */];
  var isOptionPaymentMethod = type === constants["u" /* PAYMENT_TYPE_OPTION */];
  var isOptionSuccess = type === 'OPTION' && status === 'SUCCESS';
  var isOptionFailure = type === 'OPTION' && status === 'FAILURE';
  var haveDocumentsBeenSent = query.sendDocument !== 'true';
  var enoughAdults = proposal.attendees.adults.length > 1;
  Object(useUpliftConfirmation["a" /* useUpliftConfirmation */])({
    booking: booking,
    currency: proposal.price.currency,
    paymentStatus: status
  });

  if (!isAppMounted) {
    return ConfirmationView_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])({
        'py-40': appContext.isSeller && isTablet,
        'py-95': !appContext.isSeller && isTablet,
        'pb-30 pt-20': !isTablet
      })
    }, ConfirmationView_jsx(SiteContainer["a" /* SiteContainer */], {
      size: "large"
    }, ConfirmationView_jsx("div", {
      className: "flex h-[70vh] items-center justify-center"
    }, ConfirmationView_jsx(Spinner["a" /* Spinner */], {
      iconName: icons["a" /* ICONS */].TRIDENT1
    }))));
  }

  var attendeesStatus = confirmation.attendeesStatus || [];

  var getIcon = function getIcon() {
    if (isOptionSuccess) {
      return ConfirmationView_jsx(Icon["a" /* Icon */], {
        className: "text-sienna",
        name: icons["a" /* ICONS */].CALENDAR_OPTION,
        width: "2.625em"
      });
    }

    if (isPaymentSuccess) {
      return ConfirmationView_jsx(Icon["a" /* Icon */], {
        className: "text-green",
        name: icons["a" /* ICONS */].CHECK_OUTLINE,
        width: "2.625em"
      });
    }

    if (isPaymentPending) {
      return ConfirmationView_jsx(Icon["a" /* Icon */], {
        className: "text-sienna",
        name: icons["a" /* ICONS */].CLOCK,
        width: "2.625em"
      });
    }

    if (!isPaymentSuccess || isOptionFailure) {
      return ConfirmationView_jsx(Icon["a" /* Icon */], {
        className: "text-orange",
        name: icons["a" /* ICONS */].CROSS_OUTLINE,
        width: "2.625em"
      });
    }
  };

  var getDescription = function getDescription() {
    if (isOptionSuccess) {
      return Object(i18n["h" /* t */])('booking.option.confirmation.successDescription2');
    }

    if (isPaymentSuccess) {
      return Object(i18n["h" /* t */])('booking.confirmation.bookingConfirmed');
    }

    if (isPaymentPending) {
      return ConfirmationView_jsx("p", {
        className: "text-sienna"
      }, Object(i18n["h" /* t */])('booking.confirmation.pending.description'));
    }

    if (isOptionFailure) {
      return ConfirmationView_jsx("p", {
        className: "text-orange"
      }, Object(i18n["h" /* t */])('booking.option.confirmation.failureDescription'));
    }

    if (isPaymentFailure || isPaymentFailureCM) {
      return ConfirmationView_jsx("p", {
        className: "text-orange"
      }, Object(i18n["h" /* t */])('booking.confirmation.failure.notCompletedMessage'));
    }

    if (isPaymentFailurePSP) {
      return ConfirmationView_jsx("p", {
        className: "text-orange"
      }, Object(i18n["h" /* t */])('booking.confirmation.failure.refusedPSP'));
    }
  };

  var shouldDisplayMultihouseholdsTransportWarning = proposal.households.length > 1 && proposal.transports && attendeesStatus.some(function (_ref6) {
    var hasPaid = _ref6.hasPaid;
    return hasPaid === false;
  });
  var textDataForIncentiveCC = ConfirmationView_utils_getAdequateInfosForBookingOrOption(isOptionPaymentMethod, isLogged);

  var onClickCopyPaste = function onClickCopyPaste() {
    return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CONFIRMATION, {
      detail_click: 'copy_refNumber'
    });
  };

  var onClickLogin = function onClickLogin() {
    return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CONFIRMATION, {
      detail_click: isLogged ? 'full_login' : 'quick_login'
    });
  };

  var isVisibleSalesmanIDWarningMessage = js_cookie_default.a.get("".concat(contact_info_constants["g" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(proposal.id)) === 'show';
  return ConfirmationView_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'py-40': appContext.isSeller && isTablet,
      'py-80': !appContext.isSeller && isTablet,
      'pb-30 pt-80': !appContext.isSeller && !isTablet,
      'pb-10 pt-30': appContext.isSeller && !isTablet
    })
  }, ConfirmationView_jsx(SiteContainer["a" /* SiteContainer */], {
    className: Object(classnames_utils["a" /* classnames */])({
      'mt-10 md:mt-60': !appContext.isSeller
    }),
    size: "large"
  }, !appContext.isSeller ? ConfirmationView_jsx("div", {
    className: "text-center"
  }, getIcon(), ConfirmationView_jsx("p", {
    className: "mb-0 mt-0 font-brand text-28 leading-tight sm:text-44"
  }, isOptionPaymentMethod || !isPaymentSuccess ? title : Object(i18n["h" /* t */])('booking.confirmation.bravo')), ConfirmationView_jsx("div", {
    className: "mb-20 sm:mb-120"
  }, ConfirmationView_jsx("p", {
    className: "font-brand text-18 leading-1 sm:text-24"
  }, getDescription()), isPaymentSuccess && ConfirmationView_jsx(react_default.a.Fragment, null, disclaimer ? ConfirmationView_jsx("div", {
    className: "mt-15",
    "data-testid": "durationDisclaimer"
  }, disclaimer) : null, isOptionSuccess && Boolean(duration) && ConfirmationView_jsx("div", {
    className: "mt-10"
  }, ConfirmationView_jsx(TemplateString["a" /* TemplateString */], {
    dataTestId: "optionEndDate",
    className: "font-bold text-sienna",
    template: Object(i18n["h" /* t */])('booking.option.confirmation.optionDuration'),
    values: {
      duration: duration
    }
  }))))) : ConfirmationView_jsx("div", null, ConfirmationView_jsx("div", {
    className: "flex justify-between"
  }, ConfirmationView_jsx(ConfirmationView_ConfirmationHeaderWrapper, {
    attendeesStatus: attendeesStatus,
    bookingId: bookingId,
    isOptionPaymentMethod: isOptionPaymentMethod,
    proposal: proposal,
    status: status,
    title: title
  })), message && ConfirmationView_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "large",
    className: "my-20"
  }, ConfirmationView_jsx(ConfirmationMessage_ConfirmationMessage, {
    message: message,
    status: status,
    type: type,
    isVisibleSalesmanIDWarningMessage: isPaymentSuccess && isVisibleSalesmanIDWarningMessage
  })), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('psp.cmta.confirmation.button') && query.providerId === PaymentInfo_const["i" /* NODELCRERE_CHEQUE_PSP_ID */] && ConfirmationView_jsx(Button["a" /* Button */], {
    className: "my-20",
    url: Object(i18n["h" /* t */])('booking.confirmation.redirectPaymentButton.url'),
    isExternalLink: true
  }, Object(i18n["h" /* t */])('booking.confirmation.redirectPaymentButton.label'))), !appContext.isSeller && ConfirmationView_jsx(ProductIntroductionLite_ProductIntroductionLite, {
    iconName: proposal.resort.id,
    onClickCopyPaste: onClickCopyPaste,
    onClickLogin: onClickLogin,
    productName: proposal.resort.name,
    productCountry: proposal.resort.destination.country,
    imageSrc: proposal.resort.image,
    seasonLink: null,
    isExclusiveCollection: isExclusiveCollection,
    bookingId: bookingId,
    isPaymentSuccess: isPaymentSuccess,
    title: textDataForIncentiveCC.title,
    description: textDataForIncentiveCC.description,
    cta: textDataForIncentiveCC.cta
  }), appContext.isCxo && isOptionPaymentMethod && haveDocumentsBeenSent && ConfirmationView_jsx("p", {
    className: "ms-80 flex gap-10"
  }, ConfirmationView_jsx(Icon["a" /* Icon */], {
    className: "text-red",
    name: icons["a" /* ICONS */].WARNING
  }), Object(i18n["h" /* t */])('booking.option.confirmation.noConfirmationEmail')), !isTablet && hasDonation && ConfirmationView_jsx(DonationThanks_DonationThanks, {
    isMobile: true
  }), ConfirmationView_jsx("div", {
    className: "sm:ms-100",
    "data-testid": "summary-stay"
  }, ConfirmationView_jsx("p", {
    className: "mb-25 font-brand text-24"
  }, Object(i18n["h" /* t */])('booking.confirmation.summary')), ConfirmationView_jsx(StaySummaryTicket_StaySummaryTicket, {
    isOptionFailure: isOptionFailure,
    isOptionPaymentMethod: isOptionPaymentMethod,
    isPaymentFailure: isPaymentFailure,
    isPaymentFailureCM: isPaymentFailureCM,
    optionDuration: duration,
    proposal: proposal,
    isPaymentFailurePSP: isPaymentFailurePSP
  })), isLogged && !isOptionPaymentMethod && !isPaymentFailure && enoughAdults && ConfirmationView_jsx(StayShareContainer_StayShareContainer, {
    attendees: data || [],
    bookingId: bookingId
  }), ConfirmationView_jsx("div", {
    className: "mb-60 font-brand text-24 sm:ms-100"
  }, Object(i18n["h" /* t */])('booking.confirmation.immersivesImages'))), ConfirmationView_jsx(DynamicLink["a" /* default */], {
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CONFIRMATION, {
        detail_click: "immersive_".concat(proposal.resort.id)
      });
    },
    target: "_blank",
    url: proposal.resort.href
  }, ConfirmationView_jsx(descriptor["default"], {
    layout: "full",
    pictures: (_proposal$resort$imag = proposal.resort.images) === null || _proposal$resort$imag === void 0 ? void 0 : _proposal$resort$imag.slice(0, 3).map(function (url) {
      return {
        url: url
      };
    }),
    radius: 10
  })), !isOptionPaymentMethod && !isPaymentFailure && ConfirmationView_jsx(PushAppBanner["a" /* PushAppBanner */], {
    className: "mx-auto mt-40",
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CONFIRMATION, {
        detail_click: 'download_app'
      });
    },
    onClickStoreBtn: function onClickStoreBtn(platform) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_DASHBOARD, {
        detail_click: "download_app_".concat(platform)
      });
    },
    qrImgUrl: "/img/app-qr-code-BE.png"
  }), ConfirmationView_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-20",
    size: "large"
  }, shouldDisplayMultihouseholdsTransportWarning && ConfirmationView_jsx("div", {
    className: "mx-auto flex w-1/2 items-center rounded-12 border-2 border-red p-20 text-center font-sans text-14 font-bold text-red"
  }, Object(i18n["h" /* t */])('booking.partners.confirmation.multihouseWithTransport'))));
};

/***/ }),

/***/ "ulNE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var flattenIntoArray = __webpack_require__("42ly");
var toObject = __webpack_require__("N9G2");
var toLength = __webpack_require__("tJVe");
var toInteger = __webpack_require__("i7Kn");
var arraySpeciesCreate = __webpack_require__("aoZ+");

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ "urw/":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("7St7");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ })

}]);